export default __webpack_public_path__ + "a89c450eb2c82916ec952ee6aa3c1383.svg";